import { useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import {
  ImputableProjectForSelectFragment,
  SubprojectForSelectFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ImputableProjectSelector } from 'modules/project_management/components/selectors/ImputableProjectSelector'
import type ProjectsStore from 'modules/project_management/store/models/Projects'

export interface AddProjectFormValues {
  projectId: number | undefined
  projectName: string
  projectStatus: string
  projectAssigned: boolean
  projectWorkerId: number | undefined
  subprojectName: string
  subprojectId: number | undefined
}

interface IAddProjectModalProps {
  onClose: () => void
  onSubmit: (data: AddProjectFormValues) => void
  projectsStore: ProjectsStore
  employeeId: number
}

const AddProjectModal = ({
  onClose,
  onSubmit,
  projectsStore,
  employeeId,
}: IAddProjectModalProps) => {
  const [selectedImputableProject, setSelectedImputableProject] =
    useState<ImputableProjectForSelectFragment | null>(null)

  const [selectedSubproject, setSelectedSubproject] = useState<SubprojectForSelectFragment | null>(
    null
  )

  const submitModal = () => {
    if (selectedImputableProject) {
      onSubmit({
        projectId: selectedImputableProject.id,
        projectName: selectedImputableProject.name,
        projectStatus: 'active',
        projectAssigned: true,
        projectWorkerId: projectsStore.projectsAssigned?.find(
          (project) => project.imputableProject?.id === selectedImputableProject.id
        )?.id,
        subprojectName: selectedSubproject ? selectedSubproject.name : '',
        subprojectId: selectedSubproject ? Number(selectedSubproject.id) : undefined,
      })
      trackAmplitudeEvent()
    }

    onClose()
  }

  const trackAmplitudeEvent = () => {
    track(trackingEvents.projectManagement.flexibleTracking.addProjectFromFlexibleTable, {
      projectId: selectedImputableProject?.id || '',
      subprojectId: selectedSubproject?.id || '',
    })
  }

  return (
    <Modal
      illustration={'calendar-clock'}
      title={i18n.t('project_management.my_projects.table.empty_table_message.add_button')}
      description={
        <Text size="300">{i18n.t('project_management.modals.add_project.description')}</Text>
      }
      onClose={onClose}
      onSubmit={submitModal}
      footer={<Button submit>{i18n.t('common.submit')}</Button>}
    >
      <Box gap="s16">
        <ImputableProjectSelector
          value={selectedImputableProject}
          onChange={setSelectedImputableProject}
          subprojectValue={selectedSubproject}
          onChangeSubproject={setSelectedSubproject}
          forEmployeeId={employeeId}
        />
      </Box>
    </Modal>
  )
}

export default observer(AddProjectModal)
